import lozad from "lozad";

window.environmentURLs = process.env.environmentURLs;

function detectBrowserVersion() {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];

    return "IE" + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR\/(\d+)/);
    if (tem != null) return "Opera " + tem[1];
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

  return M.join("");
}

$(function () {
  //Detect your browser version and set class name in html tag
  var _detectBrowser = detectBrowserVersion();
  $("html").addClass(_detectBrowser);

  $(".progress-bar").css("width", function () {
    return $(this).attr("aria-valuenow") + "%";
  });
});

$(window).on("load", function () {
  // Flip card on click
  $(".icon-card").on("click", function () {
    var dataStatus = $(this).attr("data-status");
    if (dataStatus === "initial") {
      $(this).attr("data-status", "clicked");
    } else {
      $(this).attr("data-status", "initial");
    }
  });
  // Change active slide onClick
  $(".navbar-nav li a").click(function (e) {
    e.preventDefault();
    $(".navbar-nav li a.active").removeClass("active");
    $(this).addClass("active");
    window.location.href = $(this).attr("href");
  });
  $("#pageContentNext").click(function (e) {
    e.preventDefault();
    var currentSlideSnum = window.location.href.split("#slide").pop();
    if (currentSlideSnum && currentSlideSnum.length < 3) {
      window.location.href = `#slide${parseInt(currentSlideSnum) + 1}`;
      $(".navbar-nav li a.active").removeClass("active");
      $(`#slide${parseInt(currentSlideSnum) + 1}`).addClass("active");
    } else {
      window.location.href = "#slide2";
      $(".navbar-nav li a.active").removeClass("active");
      $("#slide2").addClass("active");
    }
  });
  $("#pageContentPrev").click(function (e) {
    e.preventDefault();
    var currentSlideSnum = window.location.href.split("#slide").pop();
    if (currentSlideSnum && currentSlideSnum.length < 3) {
      window.location.href = `#slide${parseInt(currentSlideSnum) - 1}`;
      $(".navbar-nav li a.active").removeClass("active");
      $(`#slide${parseInt(currentSlideSnum) - 1}`).addClass("active");
    }
  });
});

// document.addEventListener('DOMContentLoaded', () => {
//   var wow = new WOW.WOW({
//     boxClass: 'wow', // animated element css class (default is wow)
//     animateClass: 'animated', // animation css class (default is animated)
//     offset: 0, // distance to the element when triggering the animation (default is 0)
//     mobile: true, // trigger animations on mobile devices (default is true)
//     live: true, // act on asynchronously loaded content (default is true)
//     callback: function (box) {
//       // the callback is fired every time an animation is started
//       // the argument that is passed in is the DOM node being animated
//     },
//     scrollContainer: null, // optional scroll container selector, otherwise use window
//   });
//   wow.init();
//   // To make it accessible globally
//   window.wow = wow;
// });

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// To make it accessible globally
window.createCookie = createCookie;

function getHistoryCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

function getCookie(name) {
  let cookieValue = "";
  let cookieArray = new Array();
  //Get cookie
  cookieValue = getHistoryCookie(name);
  if (cookieValue) {
    cookieArray = cookieValue.split(",");
  }
  return cookieArray;
}

// To make it accessible globally
window.getCookie = getCookie;

$(window).on("load", function () {
  

  import("swiper/bundle")
    .then((SwiperModule) => {
      const Swiper = SwiperModule.default;

      var swiper = new Swiper(".slider-show", {
        slidesPerView: 1,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      function equalizeSwiperSlidesHeight() {
        var maxHeight = 0;
        // Find the tallest slide
        document.querySelectorAll(".swiper-slide").forEach(function (slide) {
          maxHeight = Math.max(maxHeight, slide.offsetHeight);
        });
        // Set all slides to the tallest height
        document.querySelectorAll(".swiper-slide").forEach(function (slide) {
          slide.style.height = maxHeight + "px";
        });
      }

      function checkNavigation(swiper) {
        // Calculate effective slidesPerView based on current width and breakpoints
        let effectiveSlidesPerView = swiper.params.slidesPerView;
        const breakpoints = swiper.params.breakpoints;
        const swiperWidth = swiper.width;

        // Check breakpoints in descending order of width
        const sortedBreakpoints = Object.keys(breakpoints).sort(
          (a, b) => b - a
        );
        for (let breakpoint of sortedBreakpoints) {
          if (swiperWidth >= breakpoint) {
            effectiveSlidesPerView = breakpoints[breakpoint].slidesPerView;
            break;
          }
        }

        // Compare the number of slides with the effective slidesPerView
        if (swiper.slides.length <= effectiveSlidesPerView) {
          // Hide navigation buttons
          document.querySelector(".swiper-button-next").style.display = "none";
          document.querySelector(".swiper-button-prev").style.display = "none";
        } else {
          // Show navigation buttons
          document.querySelector(".swiper-button-next").style.display = "flex";
          document.querySelector(".swiper-button-prev").style.display = "flex";
        }
      }

      var pageContent = new Swiper(".pageContent", {
        direction: "horizontal",
        spaceBetween: 10,
        autoHeight: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      window.pageContent = pageContent; // To make it accessible globally

      const hash = window.location.hash;
      if (hash) {
        changeSlide(parseInt(hash.charAt(hash.length - 1)));
      }

      var stepsOnePaging = new Swiper(".stepsOnePaging", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        nested: true,
        autoHeight: false,
      });

      var stepsOne = new Swiper(".stepsOne", {
        pagination: ".swiper-pagination-v",
        paginationClickable: true,
        direction: "horizontal",
        spaceBetween: 50,
        nested: true,
        thumbs: {
          swiper: stepsOnePaging,
        },
      });

      var stepsTwoPaging = new Swiper(".stepsTwoPaging", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        nested: true,
      });

      var stepsTwo = new Swiper(".stepsTwo", {
        pagination: ".swiper-pagination-v",
        paginationClickable: true,
        direction: "horizontal",
        spaceBetween: 50,
        nested: true,
        thumbs: {
          swiper: stepsTwoPaging,
        },
      });
    })
    .catch((error) => console.error("Failed to load Swiper", error));
});

//Initialize Lozad.js
const lozadObserver = lozad(".lozad", {
  loaded: function (el) {
    // If the element is a background image
    if (el.getAttribute("data-background-image")) {
      el.style.backgroundImage = `url(${el.getAttribute(
        "data-background-image"
      )})`;
    }
  },
});

lozadObserver.observe();

$(window).on("load", function () {
  // console.log('loaderDisplay');
  document.getElementById("pre-load").style.display = "block";
  setTimeout(() => {
    hideLoader();
  }, 3800);
});

function toggleLoader() {
  var loaderDisplay = $("#pre-load").css("display");
  if (loaderDisplay == "none") {
    displayLoader();
  } else {
    hideLoader();
  }
}

function displayLoader() {
  document.getElementById("share").style.display = "none";
  document.getElementById("pre-load").style.display = "block";
  document.querySelector(".mainContent").style.display = "none";
  document.querySelector("body").style.overflow = "hidden !important";
}

function hideLoader() {
  document.getElementById("pre-load").style.display = "none";
  document.querySelector(".mainContent").style.display = "block";
  document.getElementById("share").style.display = "block";
  document.querySelector("body").style.overflow = "auto";
}

window.getPageNameFromURL = function getPageNameFromURL() {
  var pathname = window.location.pathname; // Get the pathname from the URL
  var regex = /\/(\w+)\.html/; // Regular expression to match '/pageName.html'
  var match = pathname.match(regex); // Use regex to find a match in the pathname

  if (match && match[1]) {
    return match[1]; // Return the page name without the '.html' part
  } else {
    return null; // No match found
  }
};
